<template>
    <v-card
            class="px-3 primary_bg_color"
            transparent
            outlined
    >
        <v-row>
            <v-col cols="3">
                <v-select
                        v-model="radius"
                        :items="availableTire"
                        height="40px"
                        label="Диаметр"
                        class="mt-2"
                        dense
                        hide-details
                        outlined
                        :rules="nameRules"
                ></v-select>
            </v-col>
            <v-col>
                <v-btn class="mr-auto mr-2" @click="solidDisk = true" height="51px" width="80px"  :class="solidDisk?'active':''">
                    <v-img :src="icon[1]" aspect-ratio="2" contain class="tabs_icons_big" alt="Литой диск"></v-img>
                </v-btn>
                <v-btn class="ml-auto" @click="solidDisk = false" height="51px" width="80px" :class="solidDisk?'':'active'">
                    <v-img :src="icon[0]" aspect-ratio="2" contain class="tabs_icons_big" alt="Штампованый диск"></v-img>
                </v-btn>
            </v-col>
<!--            <v-col>-->
<!--                <v-card height="51px" width="125px" class="v-btn text-center" :class="isRunflat?'active':''" @click="isRunflat = !isRunflat">-->
<!--                    <div class="pa-1">-->
<!--                        <div class="btn-text-top">-->
<!--                            runflat-->
<!--                        </div>-->
<!--                        <div class="btn-text-bottom">-->
<!--                            Низк. профиль-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </v-card>-->
<!--            </v-col>-->
        </v-row>
    </v-card>
</template>
<script>
    export default {
        name: 'wheelRadius',
        props: ['side', 'source'],
        data() {
            return {
              nameRules: [
                v => !!v || 'необходимо заполнить',
              ],
              icon:[
                    require('../../assets/shtamp.png'),
                    require('../../assets/litie.png')
                ],
            }
        },
        computed: {
            radius: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.radius
                },
                set(value) {
                    this.$store.dispatch(this.source+'/setRadius', { side: this.side, value })
                }
            },
            isRunflat: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.isRunflat
                },
                set(value) {
                    this.$store.commit(this.source + '/setIsRunflat', { side: this.side, value })
                }
            },
            solidDisk: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.solidDisk
                },
                set(value) {
                    this.$store.dispatch(this.source + '/changeWheelDiskType', { side: this.side, value })
                }
            },
            availableTire () {
                return this.$store.state[this.source]['availableTire']
            },
        },
    }
</script>
<style lang="scss">
    .btn-text-top {
        margin-left: 10px;
        margin-right: 10px;
        border-bottom: solid #372b2a 1px;
    }
    .btn-text-bottom {
        font-size: smaller;
        font-style: italic;
    }
    .bottom_line {
        border-bottom: #D8D8D8 1px solid;
    }
    .primary_bg_color {
        background-color: #FFFEEE !important;
    }
    .primary_bg_color .active {
        background-color: #FFFBCD !important;
    }
    .change_disk.v-btn-toggle .v-btn{
        height: 51px !important;
        width: 80px !important;
    }
    .change_disk.v-btn-toggle{
        height: 51px !important;
        width: 80px !important;
    }
    .tabs_icons_big {
        width: 40px;
        height: 40px;
    }
</style>
